import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_ITEM } from './router';

menuRegistry.registerMenu([
    {
        parent: 'SystemWide',
        key: 'Item',
        name: 'Item',
        icon: 'fa fa-store-alt',
        route: { name: ROUTE_NAME_ITEM.SYSTEM.INDEX }
    },

    {
        parent: 'General',
        key: ' ShopSetting',
        name: 'Shop Setting',
        icon: 'fas fa-store-alt',
        route: { name: ROUTE_NAME_ITEM.APP_SETTING.INDEX }
    }
]);

export default registerRouteForModule(router);
